import { HStack, Text } from '@chakra-ui/react';
import CustomChipList from '@components/common/inputs/CustomChipList';
import { stringToOption } from '@utils/components/customChipList.utils';
import { Dispatch } from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationFilterEnum, NotificationSortEnum } from '@/types/data/data.types';

type Props = {
  canSort: boolean;
  selectedFilters: NotificationFilterEnum[];
  selectedSort: NotificationSortEnum;
  setSelectedSort: Dispatch<NotificationSortEnum>;
  setSelectedFilters: Dispatch<NotificationFilterEnum[]>;
  notificationCount: Record<NotificationFilterEnum, number>;
};

export default function NotificationHeader({
  canSort,
  selectedFilters,
  selectedSort,
  notificationCount,
  setSelectedFilters,
  setSelectedSort,
}: Readonly<Props>) {
  return (
    <HStack
      width="100%"
      height="56px"
      paddingY={1.5}
      paddingX={2}
      backgroundColor="neutral.800"
      flexShrink={0}
      justifyContent="space-between"
    >
      <HStack gap={1}>
        <Text color={canSort ? 'neutral.300' : 'neutral.white'}>
          <FormattedMessage id="components.notification.show" />
        </Text>
        <CustomChipList
          availableOptions={Object.values(NotificationFilterEnum).map((value) => ({
            ...stringToOption(value),
            count: notificationCount[value],
          }))}
          selectedOptions={Array.from(selectedFilters).map(stringToOption)}
          path="components.notification.types"
          onChange={(value: string[]) => setSelectedFilters(value as NotificationFilterEnum[])}
        />
      </HStack>
      <HStack gap={1}>
        <Text color={canSort ? 'neutral.300' : 'neutral.white'}>
          <FormattedMessage id="components.panel.sort" />
        </Text>
        <CustomChipList
          availableOptions={Object.values(NotificationSortEnum).map(stringToOption)}
          selectedOptions={[stringToOption(selectedSort)]}
          path="components.notification.sort"
          distinctValues={Object.values(NotificationSortEnum)}
          canUnselectDistinct
          onChange={(value: string[]) => setSelectedSort(value[0] as NotificationSortEnum)}
        />
      </HStack>
    </HStack>
  );
}
